import { InjectionToken } from '@angular/core';
import type Keycloak from 'keycloak-js';

/** The keycloak-js instance, constructed + pre-initialised at app boot. */
export const KEYCLOAK = new InjectionToken<Keycloak>('KEYCLOAK');
